import { BOND_TYPES } from "../../Constants/AppConstants";
import { orderedBondTypeOptions } from "../OrderEntry/optionsHelper";

export const WATCHLIST_FILTER_BOND_TYPES = [
  ...orderedBondTypeOptions,
];

export const WATCHLIST_FILTER_FIELDS = {
  [BOND_TYPES.TREASURY]: [
    "securityCharge",
    "couponRange",
    "callable",
    "maturityRanges",
    "conventionMethod",
    "couponType",
    "currency",
    "incomeSource",
    "issueCurrency",
    "subType",
    "issuer",
    "insured",
    "perpetual",
    "zeroCoupon",
    // "duration",
    // "yield",
  ],
  [BOND_TYPES.MUNICIPALS]: [
    "securityCharge",
    "couponRange",
    "callable",
    "minimumRating",
    "minimumRatingMoody",
    "maturityRanges",
    "conventionMethod",
    "couponType",
    "currency",
    "state",
    "incomeSource",
    "issueCurrency",
    "subType",
    "issuer",
    "paymentFrequency",
    "callStartDate",
    "insured",
    "perpetual",
    "zeroCoupon",
    // "duration",
    // "yield",
    // "taxable",
    // "altMinTax",
  ],
  [BOND_TYPES.CORPORATES]: [
    "securityCharge",
    "couponRange",
    "callable",
    "minimumRating",
    "minimumRatingMoody",
    "maturityRanges",
    "conventionMethod",
    "couponType",
    "currency",
    "issueCurrency",
    "subType",
    "paymentFrequency",
    "incomeSource",
    "issuer",
    "sector",
    "callStartDate",
    "nextCallDate",
    "insured",
    "perpetual",
    "zeroCoupon",
    // "duration",
    // "yield",
  ],
};

export const WATCHLIST_FILTER_LABELS = {
  identifier: "Identifier",
  side: "Side",
  minimumRating: "Min S&P",
  minimumRatingMoody: "Min Moody's",
  couponRange: "Coupon Range",
  maturityRanges: "Maturity Range",
  conventionMethod: "Convention",
  couponType: "Coupon Type",
  currency: "Currency",
  duration: "Duration",
  price: "Price",
  yield: "YTM",
  zeroCoupon: "Zero Coupon",
  perpetual: "Perpetual",
  callable: "Callable",
  state: "Gov State",
  insured: "Insured",
  taxable: "Taxable",
  paymentFrequency: "Payment Freq",
  incomeSource: "Income Source",
  issueCurrency: "Issue Currency",
  altMinTax: "Alt Min Tax",
  sector: "Sector",
  callStartDate: "Call Start Date",
  nextCallDate: "Next Call Date",
  issuer: "Issuer",
  securityCharge: "Factored Securities",
  subType: "Sub Type",
};

export const WATCHLIST_FILTER_FIELD_OPTIONS = {
  side: ["BUY", "SELL"],
  callable: [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ],
  zeroCoupon: [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ],
  perpetual: [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ],
  insured: [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ],
  taxable: [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ],
  altMinTax: [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ],
};
